import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import LoggedInHomeScreen from '../Containers/LoggedIn/HomeScreen'
import LoggedInSecondaryScreen from '../Containers/LoggedIn/SecondaryScreen'
import AuthLoadingScreen from '../Containers/AuthLoadingScreen'
import LoggedOutHomeScreen from '../Containers/LoggedOut/HomeScreen'
import NoMatch from '../Containers/NoMatch'
import ResponsiveTeach from '../Containers/ResponsiveTeach'
import BB8 from '../Containers/BB8/index.js'

import ProtectedRoute from './ProtectedRoute'

const RootNavigation = () => {
  return (
    <Switch>
      <Route exact path="/" component={ResponsiveTeach} />
      <Route exact path="/BB8" component={BB8} />

      {/* <ProtectedRoute path="/LoggedInHome" component={LoggedInHomeScreen} />
      <ProtectedRoute
        path="/LoggedInSecondary"
        component={LoggedInSecondaryScreen}
      />
      <Route path="/LoggedOutHome" component={LoggedOutHomeScreen} /> */}

      {/* when none of the above match, <NoMatch> will be rendered */}
      <Route component={NoMatch} />
    </Switch>
  )
}
export default RootNavigation
